"use client";

import { c as _c } from "react/compiler-runtime";
import { Check, CircleCheck, Search, Send } from "lucide-react";
import { ActionButton, ActionWhy, lockWhile } from "@/features/home-v2/form/Action";
import { Avatar, Dialog, Spinner } from "@/features/home-v2/ui";
import { sanitizeUrl } from "@/lib/helpers";
import { useGalleryInvite } from "../../hooks/useGalleryInvite";
type Props = {
  open: boolean;
  onClose: () => void;
  galleryId: number;
  lang: "fa" | "en";
};

/**
 * Inviting a user, in v2 — the flow is `useGalleryInvite`, the one the
 * legacy GalleryInviteModal ran (search, pick, send; the invitee gets it as
 * a notification, so there is nothing to copy or share here).
 */
export default function GalleryInviteDialog(t0) {
  const $ = _c(91);
  const {
    open,
    onClose,
    galleryId,
    lang
  } = t0;
  const isFa = lang === "fa";
  let t1;
  if ($[0] !== isFa) {
    t1 = (fa, en) => isFa ? fa : en;
    $[0] = isFa;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t = t1;
  let t2;
  if ($[2] !== galleryId || $[3] !== isFa || $[4] !== open) {
    t2 = {
      open,
      galleryId,
      isFa
    };
    $[2] = galleryId;
    $[3] = isFa;
    $[4] = open;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const f = useGalleryInvite(t2);
  let t3;
  if ($[6] !== f.invited || $[7] !== f.isInviting || $[8] !== f.selectedUser || $[9] !== t) {
    t3 = f.selectedUser || f.isInviting || f.invited ? null : t("\u0627\u0648\u0644 \u06A9\u0627\u0631\u0628\u0631 \u0631\u0627 \u067E\u06CC\u062F\u0627 \u0648 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.", "Find and pick the person first.");
    $[6] = f.invited;
    $[7] = f.isInviting;
    $[8] = f.selectedUser;
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <ActionWhy id="gs-invite-why">{t3}</ActionWhy>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = f.isInviting;
  let t6;
  if ($[13] !== t) {
    t6 = t("\u0628\u0633\u062A\u0646", "Close");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== f.isInviting || $[16] !== onClose || $[17] !== t6) {
    t7 = <button type="button" className="v2-btn v2-btn--ghost v2-focus" onClick={onClose} disabled={t5}>{t6}</button>;
    $[15] = f.isInviting;
    $[16] = onClose;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = f.isInviting;
  const t9 = !f.selectedUser;
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Send aria-hidden={true} />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("\u062F\u0631 \u062D\u0627\u0644 \u0627\u0631\u0633\u0627\u0644\u2026", "Sending\u2026");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== f.invited || $[23] !== t) {
    t12 = f.invited ? t("\u0627\u0631\u0633\u0627\u0644 \u062F\u0639\u0648\u062A \u062F\u06CC\u06AF\u0631", "Send another") : t("\u0627\u0631\u0633\u0627\u0644 \u062F\u0639\u0648\u062A\u200C\u0646\u0627\u0645\u0647", "Send invitation");
    $[22] = f.invited;
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== f.isInviting || $[26] !== t11 || $[27] !== t12 || $[28] !== t9) {
    t13 = <ActionButton type="submit" form="gs-invite" busy={t8} blocked={t9} whyId="gs-invite-why" onBlocked={_temp} icon={t10} busyLabel={t11}>{t12}</ActionButton>;
    $[25] = f.isInviting;
    $[26] = t11;
    $[27] = t12;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t4 || $[32] !== t7) {
    t14 = <div className="gs-dlg-foot">{t4}{t7}{t13}</div>;
    $[30] = t13;
    $[31] = t4;
    $[32] = t7;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const footer = t14;
  let t15;
  if ($[34] !== t) {
    t15 = t("\u062F\u0639\u0648\u062A \u0628\u0647 \u06AF\u0627\u0644\u0631\u06CC", "Invite to the gallery");
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t) {
    t16 = t("\u0628\u0633\u062A\u0646", "Close");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  const t17 = f.isInviting;
  let t18;
  if ($[38] !== f) {
    t18 = e => {
      e.preventDefault();
      f.invite();
    };
    $[38] = f;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== f.isInviting) {
    t19 = lockWhile(f.isInviting);
    $[40] = f.isInviting;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t) {
    t20 = t("\u06A9\u0627\u0631\u0628\u0631 \u0631\u0627 \u067E\u06CC\u062F\u0627 \u06A9\u0646\u06CC\u062F\u061B \u062F\u0639\u0648\u062A\u200C\u0646\u0627\u0645\u0647 \u0628\u0647\u200C\u0635\u0648\u0631\u062A \u0627\u0639\u0644\u0627\u0646 \u0628\u0631\u0627\u06CC\u0634 \u0645\u06CC\u200C\u0631\u0648\u062F.", "Find the person \u2014 the invitation reaches them as a notification.");
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t20) {
    t21 = <p className="gs-dlg-lead">{t20}</p>;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Search aria-hidden={true} />;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t) {
    t23 = t("\u062C\u0633\u062A\u062C\u0648\u06CC \u06A9\u0627\u0631\u0628\u0631", "Search a user");
    $[47] = t;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t23) {
    t24 = <span className="v2-sr-only">{t23}</span>;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  const t25 = f.search;
  let t26;
  if ($[51] !== f) {
    t26 = e_0 => f.setSearch(e_0.target.value);
    $[51] = f;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t) {
    t27 = t("\u0646\u0627\u0645 \u06CC\u0627 \u0646\u0627\u0645 \u06A9\u0627\u0631\u0628\u0631\u06CC", "Name or username");
    $[53] = t;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== f.search || $[56] !== t26 || $[57] !== t27) {
    t28 = <input id="gs-invite-search" value={t25} onChange={t26} placeholder={t27} autoComplete="off" />;
    $[55] = f.search;
    $[56] = t26;
    $[57] = t27;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t24 || $[60] !== t28) {
    t29 = <label className="gs-search">{t22}{t24}{t28}</label>;
    $[59] = t24;
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t) {
    t30 = t("\u0646\u062A\u06CC\u062C\u0647\u200C\u0647\u0627", "Results");
    $[62] = t;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== f || $[65] !== t) {
    t31 = f.isSearching ? <div className="gs-dlg-state" role="status"><Spinner />{t("\u062F\u0631 \u062D\u0627\u0644 \u062C\u0633\u062A\u062C\u0648\u2026", "Searching\u2026")}</div> : f.results.length > 0 ? f.results.map(a => {
      const on = f.selectedUser?.id === a.id;
      return <button key={a.id} type="button" role="option" aria-selected={on} className="gs-person v2-focus" onClick={() => f.pick(a)}><Avatar name={a.name || a.username || ""} src={sanitizeUrl(a.profile?.cover ?? undefined) || null} size={34} /><span><b>{a.name || a.username}</b>{a.username ? <small dir="ltr">@{a.username}</small> : null}</span>{on ? <Check aria-hidden={true} className="gs-person-on" /> : null}</button>;
    }) : <p className="gs-dlg-state">{f.debouncedSearch.trim() ? t("\u06A9\u0627\u0631\u0628\u0631\u06CC \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F", "No one found") : t("\u0628\u0631\u0627\u06CC \u0634\u0631\u0648\u0639\u060C \u0646\u0627\u0645 \u06A9\u0627\u0631\u0628\u0631 \u0631\u0627 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F", "Start by typing a name")}</p>;
    $[64] = f;
    $[65] = t;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] !== t30 || $[68] !== t31) {
    t32 = <div className="gs-people" role="listbox" aria-label={t30}>{t31}</div>;
    $[67] = t30;
    $[68] = t31;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== f.error) {
    t33 = f.error ? <p className="gs-dlg-error" role="alert">{f.error}</p> : null;
    $[70] = f.error;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  let t34;
  if ($[72] !== f.invited || $[73] !== t) {
    t34 = f.invited ? <p className="gs-dlg-done" role="status"><CircleCheck aria-hidden={true} />{t("\u062F\u0639\u0648\u062A\u200C\u0646\u0627\u0645\u0647 \u0628\u0631\u0627\u06CC \u06A9\u0627\u0631\u0628\u0631 \u0641\u0631\u0633\u062A\u0627\u062F\u0647 \u0634\u062F.", "The invitation was sent.")}</p> : null;
    $[72] = f.invited;
    $[73] = t;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] !== t18 || $[76] !== t19 || $[77] !== t21 || $[78] !== t29 || $[79] !== t32 || $[80] !== t33 || $[81] !== t34) {
    t35 = <form id="gs-invite" className="gs-invite" onSubmit={t18} {...t19}>{t21}{t29}{t32}{t33}{t34}</form>;
    $[75] = t18;
    $[76] = t19;
    $[77] = t21;
    $[78] = t29;
    $[79] = t32;
    $[80] = t33;
    $[81] = t34;
    $[82] = t35;
  } else {
    t35 = $[82];
  }
  let t36;
  if ($[83] !== f.isInviting || $[84] !== footer || $[85] !== onClose || $[86] !== open || $[87] !== t15 || $[88] !== t16 || $[89] !== t35) {
    t36 = <Dialog open={open} onClose={onClose} title={t15} closeLabel={t16} footer={footer} className="gs-dialog" busy={t17}>{t35}</Dialog>;
    $[83] = f.isInviting;
    $[84] = footer;
    $[85] = onClose;
    $[86] = open;
    $[87] = t15;
    $[88] = t16;
    $[89] = t35;
    $[90] = t36;
  } else {
    t36 = $[90];
  }
  return t36;
}
function _temp() {
  return document.getElementById("gs-invite-search")?.focus();
}